<template>
  <div class="mine-wrapper">
    <Heador />

    <!-- 列表菜单 -->
    <div class="menu-block">
      <div class="menu-item step1" @click="$router.push({ name: 'driverList' })">
        <div class="menu-icon icon-blue">
          <van-icon name="manager-o" size="20" />
          <div class="dot-indicator" v-if="yhjsybaztslot"></div>
        </div>
        <div class="menu-title">驾驶员信息管理</div>
        <div class="menu-right">
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="menu-item step2" @click="$router.push({ name: 'escortList' })">
        <div class="menu-icon icon-purple">
          <van-icon name="friends-o" size="20" />
          <div class="dot-indicator" v-if="yhyyybaztslot"></div>
        </div>
        <div class="menu-title">押送员信息管理</div>
        <div class="menu-right">
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="menu-item step3" @click="$router.push({ name: 'chetouList' })">
        <div class="menu-icon icon-orange">
          <van-icon name="logistics" size="20" />
          <div class="dot-indicator" v-if="yhctbaztslot"></div>
        </div>
        <div class="menu-title">车头信息管理</div>
        <div class="menu-right">
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="menu-item step4" @click="$router.push({ name: 'cheguaList' })">
        <div class="menu-icon icon-green">
          <van-icon name="exchange" size="20" />
          <div class="dot-indicator" v-if="yhcgbaztslot"></div>
        </div>
        <div class="menu-title">车挂信息管理</div>
        <div class="menu-right">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="menu-block step5">
      <a href="tel:0510-86092982" class="menu-item">
        <div class="menu-icon icon-red">
          <van-icon name="phone-o" size="20" />
        </div>
        <div class="menu-title">联系我们</div>
        <div class="menu-right">
          <span class="phone-number">0510-86092982</span>
          <van-icon name="arrow" />
        </div>
      </a>

      <!--    <div class="menu-item" @click="$router.push({name:'clearCache'})">-->
      <!--      <div class="menu-icon icon-orange">-->
      <!--        <van-icon name="delete-o" size="20" />-->
      <!--      </div>-->
      <!--      <div class="menu-title">清除缓存</div>-->
      <!--      <div class="menu-right">-->
      <!--        <van-icon name="arrow" />-->
      <!--      </div>-->
      <!--    </div>-->
    </div>
    <!--  <button @click="redictTo">人脸识别测试</button>-->

    <!-- 底部版权 -->
    <div class="footer-copyright">
      <p>苏豪丽天智储 版权所有</p>
    </div>

    <Tabbar></Tabbar>
  </div>
</template>

<script>
  import Heador from '../Home/headerTpl.vue';
  import Tabbar from '../Public/tabbarTpl.vue';
  import api from '@/fetch/api';
import store from '@/store';

  export default {
    components: {
      Heador,
      Tabbar,
    },
    data() {
      return {
        yhcgbaztslot: false,
        yhctbaztslot: false,
        yhjsybaztslot: false,
        yhyyybaztslot: false,
      };
    },
    created() {
      document.title = '个人信息';
      this.getBindVehicleState();
    },
    mounted() {
      if (store.state.isFirstTime) {
        // 根据不同的查询参数, 设置不同的引导步骤
        if (!this.$route.query?.bootFlag) {

          this.$driverObj.highlight({
            element: ".step1",
            popover: {
              title: "第一步",
              description: "绑定驾驶员信息"
            }
          });
        } else if (this.$route.query.bootFlag === 'second') {
          this.$driverObj.highlight({
            element: ".step2",
            popover: {
              title: "第二步",
              description: "绑定押运员信息"
            }
          });
        }
      }
    },
    destroyed() {
      this.$driverObj.destroy();
    },
    methods: {
      //判断是否绑定车辆
      getBindVehicleState() {
        var openid = this.$store.state.wx_info.openid;
        var that = this;
        api
          .getBindVehicleState(openid)
          .then(function (resData) {
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              that.$data.vehicleState = res.data.yhzt;
              var yhcgbazt = res.data.yhcgbazt;
              var yhctbazt = res.data.yhctbazt;
              var yhjsybazt = res.data.yhjsybazt;
              var yhyyybazt = res.data.yhyyybazt;
              let yhcgbaztslot = 0,
                yhctbaztslot = 0,
                yhjsybaztslot = 0,
                yhyyybaztslot = 0;
              // 0=未绑定 1=未提交 2=待审核 3=审核成功；非 3 都显示红点
              if (yhcgbazt !== '3') yhcgbaztslot++;
              if (yhctbazt !== '3') yhctbaztslot++;
              if (yhjsybazt !== '3') yhjsybaztslot++;
              if (yhyyybazt !== '3') yhyyybaztslot++;
              that.$data.yhcgbaztslot = yhcgbaztslot ? true : false;
              that.$data.yhctbaztslot = yhctbaztslot ? true : false;
              that.$data.yhjsybaztslot = yhjsybaztslot ? true : false;
              that.$data.yhyyybaztslot = yhyyybaztslot ? true : false;
            }
          })
          .catch(function () {
            //
          });
      },
      redictTo() {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1f7125112b74db52&redirect_uri=https%3A%2F%2Fopen.faceid.qq.com%2Fv1%2Fapi%2FgetCode%3FbizRedirect%3Dhttps%253A%252F%252Ffaceid.qq.com%252Fapi%252Fauth%252FgetOpenidAndSaveToken%253Ftoken%253D872CAEF6-1E5D-4A7D-AF08-36D8C3CEE6AD&response_type=code&scope=snsapi_base&state=&component_appid=wx9802ee81e68d6dee#wechat_redirect';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mine-wrapper {
    min-height: 100vh;
    background-color: #f7f8fa;
    padding-bottom: 60px;
  }

  /* 菜单块 */
  .menu-block {
    background: #fff;
    border-radius: 12px;
    margin: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    overflow: hidden;

    & + .menu-block {
      margin-top: 20px;
    }
  }

  /* 菜单项 */
  .menu-item {
    display: flex;
    align-items: center;
    padding: 16px;
    position: relative;
    text-decoration: none;
    color: inherit;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 16px;
      right: 16px;
      height: 1px;
      background-color: #f5f6f7;
    }

    .menu-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      position: relative;

      &.icon-blue {
        background-color: rgba(64, 128, 255, 0.1);
        .van-icon {
          color: #4080ff;
        }
      }

      &.icon-purple {
        background-color: rgba(135, 100, 230, 0.1);
        .van-icon {
          color: #8764e6;
        }
      }

      &.icon-orange {
        background-color: rgba(255, 164, 38, 0.1);
        .van-icon {
          color: #ffa426;
        }
      }

      &.icon-green {
        background-color: rgba(42, 190, 125, 0.1);
        .van-icon {
          color: #2abe7d;
        }
      }

      &.icon-red {
        background-color: rgba(238, 10, 36, 0.1);
        .van-icon {
          color: #ee0a24;
        }
      }

      .dot-indicator {
        position: absolute;
        top: -3px;
        right: -3px;
        width: 8px;
        height: 8px;
        background-color: #ff4d4f;
        border-radius: 50%;
      }
    }

    .menu-title {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }

    .menu-right {
      display: flex;
      align-items: center;

      .phone-number {
        margin-right: 8px;
        font-size: 14px;
        color: #969799;
      }

      .van-icon {
        color: #c8c9cc;
        font-size: 16px;
      }
    }
  }

  /* 底部版权 */
  .footer-copyright {
    text-align: center;
    padding: 20px 0 30px;

    p {
      font-size: 12px;
      color: #969799;
      margin: 0;
    }
  }
</style>
